import React from "react";

const Header = () => {
  return (
    <header className="heading">
      <div className="corner-ribbon"><a href="https://github.com/jhkette/react-ml5-library">View code</a></div>
      <div>
        <h1>Image classifier</h1>
      </div>
    </header>
  );
};

export default Header;
